import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

interface NetworkPrintersState {
  hasFailed: boolean;
  isInitialized: boolean;
  printers: dashboard.BusinessPrinter[];
  requestInProgress: boolean;
}

const initialState: NetworkPrintersState = {
  hasFailed: true,
  isInitialized: false,
  printers: [],
  requestInProgress: false,
};

export default function reducer(
  state: NetworkPrintersState = initialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): NetworkPrintersState {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.NETWORK_PRINTERS_FETCH_ALL_DONE:
      return {
        ...state,
        hasFailed: false,
        isInitialized: true,
        printers: payload,
        requestInProgress: false,
      };

    case AppConstants.NETWORK_PRINTERS_FETCH_ALL_FAILED:
      return {
        ...state,
        hasFailed: true,
        isInitialized: true,
        requestInProgress: false,
      };

    case AppConstants.NETWORK_PRINTERS_FETCH_ALL_STARTING: {
      return {
        ...state,
        hasFailed: false,
        requestInProgress: true,
      };
    }

    default:
      return state;
  }
}
